<script lang="ts">
  import { StatusEnum } from '../../../../types'

  export let status: StatusEnum
</script>

<div class="status {status}">
  {#if status === StatusEnum.DRAFT} черновик {/if}
  {#if status === StatusEnum.DELAYED} отложено {/if}
  {#if status === StatusEnum.OTHER} другое {/if}
  {#if status === StatusEnum.PUBLISHED} опубликовано {/if}
  {#if status === StatusEnum.DEACTIVATED} деактивировано {/if}
</div>

<style lang="scss">
  .status {
    padding: 5px 10px;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.04em;
    text-align: center;
    border-radius: 30px;
    box-sizing: border-box;
    text-transform: uppercase;
    white-space: nowrap;

    &.published {
      color: #0C8C6D;
      background-color: #D0F1E1;
    }

    &.delayed {
      color: #FFAE30;
      background-color: #FFEFDC;
    }

    &.draft {
      color: #FA624B;
      background-color: #FFE1E5;
    }

    &.other {
      color: #fa4b9a;
      background-color: #f4dfe8;
    }

    &.deactivated {
      color: #30333D;
      background-color: #E0E8F6;
    }

    &.other {
      color: #30333D;
      background-color: white;
      border: 1px solid #E0E8F6;
    }
  }
</style>